import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setWeightOptions } from '../store/options.actions'

export function* getWeightOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getWeightOptions,
    ])
    const { entity } = response
    yield put(setWeightOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getWeightOptions() error: ${e}`))
  }
}

export function* getWeightOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getWeightOptions)
}
